export const setAuthToken = (token: string) => {
    // Store token in both localStorage and sessionStorage for consistency
    localStorage.setItem('authToken', token);
    sessionStorage.setItem('authToken', token);
    sessionStorage.setItem('token', token);
};

export const getAuthToken = () => {
    // Check both localStorage and sessionStorage for both 'token' and 'authToken' keys
    return localStorage.getItem('authToken') || 
           sessionStorage.getItem('authToken') || 
           localStorage.getItem('token') || 
           sessionStorage.getItem('token');
};

export const clearAuthToken = () => {
    // Clear token from all storage locations
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('token');
};

// Django backend uses custom authentication that expects X-Authorization header
// (not the standard Authorization header) due to Safari browser compatibility issues
export const AUTHORIZATION_HEADER_NAME = 'X-Authorization';
// export const AUTHORIZATION_HEADER_NAME = 'Authorization';